module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Title page")]), _vm._v(": Neyland County No. 1027 County of Stafford approaching its stop at Clynderwen at 3.24pm with the 2.40pm Neyland to Paddington in June 1962. The six coach portion would run through to Swansea where a dining portion would be added for its 5.30pm departure to Paddington. (M.J. Esau)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1t"
  }, [_vm._v("First published in Great Britain in 2021 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen and Sword Transport")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("An imprint of")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Yorkshire - Philadelphia")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Copyright © John Hodge, 2021")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("ISBN 978 1 52679 578 6")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ePUB ISBN 978 1 52679 579 3")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mobi ISBN 978 1 52679 579 3")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("The right of John Hodge to be identified as Author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("A CIP catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the Imprints of Pen & Sword Books Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Transport, True Crime, Fiction, Frontline Books, Leo Cooper, Praetorian Press, Seaforth Publishing, Wharncliffe and White Owl.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("For a complete list of Pen & Sword titles please contact")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("PEN & SWORD BOOKS LIMITED")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("enquiries@pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("or")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("PEN AND SWORD BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1950 Lawrence Rd, Havertown, PA 19083, USA")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto://Uspen-and-sword@casematepublishers.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Uspen-and-sword@casematepublishers.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.penandswordbooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.penandswordbooks.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0